import React, { useEffect, useState } from "react";

import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAdmin } from "../components/AdminProvider";
import { API_URL } from "../constants";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";

const useAuth = () => {
  const user = localStorage.getItem("token");
  // if (user) {
  //   return true;
  // } else {
  //   return false;
  // }
  return false;
};

const PublicRoute = () => {
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  // const token = localStorage.getItem("token");
  const { setAdminData, adminData } = useAdmin();

  useEffect(() => {
    if (adminData.data !== null) {
      setLoading(false);
      return;
    }
    async function checkAuth() {
      try {
        const { data } = await axios.post(
          `${API_URL}create/admin/checkAuth`,
          {},
          { withCredentials: true }
        );

        if (data.data.auth) {
          navigate("/dashboard");
          setAdminData((adminData) => ({
            ...adminData,
            data: data.data.admin,
          }));
          return;
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return (
      <Box
        display={"flex"}
        height={"100vh"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  // return <Outlet />;

  if (adminData.data !== null) {
    return <Navigate to="/dashboard" />;
  } else {
    return <Outlet />;
  }
};

export default PublicRoute;
